<script setup lang="ts">
import { inject, onMounted, onUnmounted } from 'vue'
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import Icon from '@/Components/Utils/Icon.vue'
import { useFormatTime } from '@/Composables/useFormatTime'
import { layoutStructure } from '@/Composables/useLayoutStructure'

const layout = inject('layout', layoutStructure)

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    root_active?: string
    data: {}
}>()

onMounted(() => {
    layout.root_active = props.root_active ?? ''
})

onUnmounted(() => {
    layout.root_active = ''
})


</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    <Table :resource="data" name="default">
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(reference)="{ item }">
            <Link :href="route('manufacture.manufactures.show', item.slug)" class="primaryLink">
                {{ item.reference }}
            </Link>
        </template>

        <template #cell(order)="{ item }">
            <Link :href="route('casheer.orders.show', item.order?.slug)" class="secondaryLink">
                {{ item.order?.reference }}
            </Link>
        </template>

        <template #cell(customer)="{ item }">
            {{ item.order?.customer?.name ?? '-' }}
        </template>

        <template #cell(product_name)="{ item }">
            <div>
                <div class="font-bold">
                    <Icon :data="item.order?.type_icon" />
                    {{ item.order?.product_snapshot?.name ?? '-' }}
                </div>
                <div v-if="item.order?.type === 'flexo'" class="text-sm italic opacity-70">
                    ({{ item.order?.product_snapshot?.dimension_width }} × {{ item.order?.product_snapshot?.dimension_height }} cm)
                </div>
            </div>
        </template>

        <template #cell(quantity)="{ item }">
            {{ item.order?.quantity }}
        </template>

        <template #cell(state)="{ item }">
            <div class="flex items-center gap-x-1.5">
                <Icon :data="item.state_icon" />
                <span>{{ item.state_label }}</span>
            </div>
        </template>

        <template #cell(finished_at)="{ item }">
            {{ item.finished_at ? useFormatTime(item.finished_at) : '-' }}
        </template>
    </Table>
</template>
